import { useContext } from "react";
import { FormattedMessage } from "react-intl";

import { RanaHeading } from "@nens/ranalib";
import { TenantContext } from "@nens/ranalib";

import { BasePage } from "@/components/base-page";
import { Catalogue } from "@/lib/catalogue";
import { useTenantQuery } from "@/queries/query-tenant";

export function TenantCataloguePage() {
  const { tenant } = useContext(TenantContext);
  const tenantResponse = useTenantQuery();
  const tenantName = tenantResponse.data ? tenantResponse.data.name : tenant;

  return (
    <BasePage
      activeSidebarButton="catalogue"
      pageSubTitle={<FormattedMessage id="page_title.catalogue" defaultMessage="Catalogue" />}
    >
      <RanaHeading type="h1" addDot>
        <FormattedMessage
          id="heading.catalogue"
          defaultMessage="Catalogue for {name}"
          values={{ name: tenantName }}
        />
      </RanaHeading>
      <Catalogue />
    </BasePage>
  );
}
